module.exports = __webpack_public_path__ + "static/media/28.71b031fb.png";